import { AlertProps } from "@mui/material/Alert";
import { useTranslation } from "react-i18next";

export const useMuiTableToolbarAlertBannerProps = (
  isDataLoadingError: boolean,
  statusText?: string | Error | null
) => {
  const { t } = useTranslation();

  return isDataLoadingError
    ? ({
        color: "error",
        children: t("errorLoadingTableData", {
          error: `${statusText ? ":" + statusText : ""}`,
        }),
      } as AlertProps)
    : undefined;
};
